export default "<div *ngIf=\"isLoading\"  class=\"loader\">\n  <i class=\"fa fa-spinner\"></i>\n</div>\n"